import { Component, OnInit, ViewChild } from '@angular/core';
import { ServerService } from '../services/server.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthServiceService } from '../services/auth-service.service';


@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.css']
})





export class EditProfileComponent implements OnInit { 
  resp:any;
  error:any;
  errorMsg:any;
  @ViewChild('f', {static: false}) form:NgForm;
  constructor(private serverService:ServerService,
    private router:Router,
    private ngxService:NgxUiLoaderService,
    private authService:AuthServiceService,
    private dialogRef:MatDialogRef<EditProfileComponent>
   ) { }

  ngOnInit() { 
    this.serverService.getInfo()
    .subscribe(
      (response) => {
        this.resp  = response;
      this.form.setValue({
        email:this.resp.email,
        name:this.resp.name,
         username:this.resp.username, 
        });
      
      },);
  }
  onClose(){
    this.dialogRef.close();
   
  }

  editInfo(form:NgForm){
   
    this.ngxService.start();
    const value = form.value;
    this.serverService
    .changeInfo(value.email, value.name, value.username)
    .subscribe(
      (response) => {
        this.ngxService.stop();
        
        this.resp = response; 
        if(this.resp){ 
          form.reset();}
        
        Swal.fire("Success",
          this.resp.message,
          "success",);
        if (this.resp.message ){
          
            form.reset(); 
            this.onClose();
          this.router.navigate(['/verify', this.resp.username]);
          // this.authService.loggedOut();
           
          
        }
        else{
          form.reset(); 
          this.onClose();
          // this.router.navigate(['/myProfile']);
        }
         
  
        },
        
         

        (error) => {
          this.ngxService.stop();
          this.error= error
          Swal.fire("Oops!",
            this.error.error.message,
            "error"
           );
           
         
            
           
             
            
            
            
  
          
         
          }

    );}

}






